import styles from '../../map.module.css';
import React, { useEffect, useState, useCallback } from 'react';
import { useSelectedCoastalSegmentGroup, useSetSelectedCoastalSegmentGroup } from '../../hooks/useMapStore';
import { IconPicker } from 'components/layout/icons/IconPicker';
import { isNumeric } from '@progress/kendo-data-query/dist/npm/utils';

export const MapInfoPanelCoastalSegmentGroup = () => {

    const [show, setShow] = useState<boolean>(false);

    const selectedCoastalSegmentGroup = useSelectedCoastalSegmentGroup();
    const setSelectedCoastalSegmentGroup = useSetSelectedCoastalSegmentGroup();

    const onClose = useCallback((e?: React.MouseEvent | React.KeyboardEvent) => {
        // Prevent bubbling to the map container
        e?.stopPropagation();
        setSelectedCoastalSegmentGroup(null);
    }, [setSelectedCoastalSegmentGroup]);

    useEffect(() => {
        setShow(selectedCoastalSegmentGroup !== null && selectedCoastalSegmentGroup?.name);
    }, [selectedCoastalSegmentGroup]);

    return (
        (show) &&
            <div className={`${styles.infoWindow} ${styles.infoWindowMobile}`}>
                <div className={styles.infoWindowHeader}>
                    <div className="font-size-lg text-truncate">
                        {selectedCoastalSegmentGroup?.name}
                    </div>
                    <div onClick={onClose}>
                        <IconPicker icon="x" size={20} weight="regular" />
                    </div>
                </div>
                <div className={styles.infoWindowBody }>
                    <div className={`${styles.infoWindowText} font-size-md`}>
                        <IconPicker icon="squares-four" size={90} />
                    </div>
                    <div className={`${styles.infoWindowContent}`} style={{ padding: 20}}>
                        <div className="k-d-grid k-gap-1 font-size-md">
                            {
                                (isNumeric(selectedCoastalSegmentGroup?.areaSqKilometers)) &&
                                <>
                                    <div>St&oslash;rrelse p&aring; omr&aring;det:</div>
                                    <div><b>{selectedCoastalSegmentGroup?.areaSqKilometers?.toFixed(2)} km<sup>2</sup></b></div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
    );
}
